import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext({ language: "de", setLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const fromStorage = typeof window !== "undefined" ? window.localStorage.getItem("lang") : null;
    return fromStorage || "de"; // default to German
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("lang", language);
    } catch (_) {}
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);







